import { useWorkspaceText } from '../interface-copy';
import { useCompany } from '@/company/context';
import { LoadingState } from '../primitives';
import { ArtifactLibrary, type ArtifactLibraryProps } from './artifact-library';

/**
 * The Artifact Library, mounted only for the committed account and company. A direct link or a reload
 * renders this page before the company bootstrap answers; a read sent then goes out without the identity
 * pair (the server's 409). Until both are known it shows the existing loading state and reads nothing.
 */
export function ArtifactLibraryGate(props: ArtifactLibraryProps) {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  const company = useCompany().data;
  const resolved = Boolean(company?.company?.id && company.membership?.userId);
  if (!resolved) return <LoadingState label={uiText('Loading library…')} />;
  return <ArtifactLibrary {...props} />;
}
